export const CONTACT_EMAIL = "contact@sunnyvacationclub.com";
export const WHATSAPP_NUMBER = "34603184255";
export const WHATSAPP_DISPLAY = "+34 603 18 42 55";
export const OFFICE_PHONE_DISPLAY = "+216 73 682 400";
export const OFFICE_PHONE_TEL = "+21673682400";
export const CONTACT_ADDRESS = "BP 196 Zone Touristique, 5111, Hiboun, Tunisia";
export const INSTAGRAM_URL = "https://www.instagram.com/sunnyvacationclub/";
export const INSTAGRAM_DISPLAY = "@sunnyvacationclub";
export const REAL_ESTATE_SELLER = "International Tourism Company";
export const MANAGEMENT_COMPANY = "Sunny Sales and Marketing Entreprise";
export const VACATION_CLUB_BRAND = "Sunny Vacation Club";
export const OFFICIAL_CONTACTS = [
  { label: "Tunisia", display: "+216 22 863 922", tel: "+21622863922", whatsapp: "21622863922" },
  { label: "Indonesia", display: "+62 857 7075 9300", tel: "+6285770759300", whatsapp: "6285770759300" },
  { label: "Spain / International", display: "+34 603 18 42 55", tel: "+34603184255", whatsapp: "34603184255" },
];
